import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MessagingChannelBasic } from 'src/app/swagger-api';
import { BaseCacheService } from './base-cache-helper.service';

@Injectable({ providedIn: 'root' })
export class ChatChannelService extends BaseCacheService<MessagingChannelBasic> {
  protected override fetchFromApi(): Observable<MessagingChannelBasic> {
    return this.apiService.restSocialProfileMessagingNotifyChannelGet();
  }

  public override getLocalStorageKey(): string {
    return 'chat-channel-data';
  }
}
